import { DotNetFormulaResultModel } from 'src/domain/dynamic-form/models';
import { FormulaTypeBaseHandler } from './formula-type-base.handler';

export class NumberFormulaTypeHandler extends FormulaTypeBaseHandler {
	public handle(formula: DotNetFormulaResultModel, decimals: number): string | number {
		if (formula.result !== null && formula.result !== undefined) {
			if (decimals !== null) {
				return Number(parseFloat(formula.result.toString()).toFixed(decimals));
			}

			return formula.result.toString();
		}

		return this.next.handle(formula, decimals);
	}
}
